import React from 'react';
import {connectWithCore} from 'framework/hocs';
import _ from 'lodash';
import {checkIfEmailIsValid} from '../../common/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {
  RadioField,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {FileUpload} from 'go/components/common/attachments';
import {Button, Input, Form} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {Alert} from 'componentLibrary';

export class PanelReviewAddReviewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newReviewerId: '',
      error: false,
      errorCode: '',
      addPanelist: 'single',
      selectedFile: [],
      uploadError: false,
      emailError: '',
      disableAdd: true,
    };
  }

  handleInputChange = (event) => {
    const {value} = event.target;
    this.setState((prevState) => {
      return {addPanelist: value};
    });
  };

  handleEmailChange = (event) => {
    const {name, value} = event.target;
    if (value.length == 0) {
      this.setState({...this.state, [name]: '', emailError: '', disableAdd: true});
      return;
    }

    if (checkIfEmailIsValid(value)) {
      this.setState({...this.state, [name]: value, emailError: '', disableAdd: false});
    } else {
      this.setState({
        ...this.state,
        [name]: value,
        emailError: 'You must use a valid Email address',
        disableAdd: true,
      });
    }
  };

  clearErrors = () => {
    this.setState((prevState) => ({...prevState, errorCode: ''}));
  };

  noRowsError() {
    return (
      <React.Fragment>
        <Alert header="Error in Excel document:" type="error">
          <strong>
            Please make sure you input at least one reviewer id in the template.
          </strong>
        </Alert>
      </React.Fragment>
    );
  }

  uploadAttachment = (error, files) => {
    this.props.setUploadError(error);
    if (!_.isEmpty(files)) {
      this.setState({
        selectedFile: files[0],
      });
    }
  };

  downloadTemplateLink = () => {
    return REST.panelReviewV2.getPanelsAttachment();
  };

  render() {
    const {
      error,
      errorText,
      selectedFile,
      newReviewerId,
      emailError,
      disableAdd,
    } = this.state;
    let btnLabel = 'Add reviewer';
    let disableSave = false;

    if (this.state.addPanelist === 'bulk') {
      btnLabel = 'Save';
      disableSave = _.isEmpty(selectedFile);
    }

    return (
      <FemaGoModal
        open={this.props.showModal === true}
        title="Add reviewer"
        cancelAction={() => {
          this.props.openManageTeamModal();
        }}
        confirmAction={async () => {
          this.props.openManageTeamModal();
          this.state.addPanelist === 'single'
            ? await this.props.addReviewerRole(newReviewerId)
            : await this.props.saveReviewerRole(selectedFile);
          this.props.getReviewers();
          this.setState({...this.state, newReviewerId: ''});
        }}
        buttonText={btnLabel}
        disableButton={
          this.state.addPanelist === 'bulk'
            ? this.props.uploadError || disableSave
            : disableAdd
        }
      >
        <Form>
          <RadioField
            id="addPanelReviewerOptions"
            name="addPanelReviewerOptions"
            value={this.state.addPanelist}
            handleChange={this.handleInputChange}
            handleBlur={this.props.handleBlur}
            options={[
              {label: 'Add single panelist', value: 'single'},
              {label: 'Bulk upload panelists', value: 'bulk'},
            ]}
          />
          {this.state.addPanelist === 'single' && (
            <div>
              <p>
                {
                  'For FEMA users, please use PIV-ID email addresses (e.g. 012345678@dhs.gov) for access to competitive merit review sessions. Once you upload your panelist, you will see them in the panel reviewer list where they will be initially listed as inactive until you are ready to activate them.'
                }
              </p>
              <p>
                {
                  'For non-FEMA users, please use the email address that the panelist will use for logging in to panel session.'
                }
              </p>
              <p>
                <strong>Input the email to add the user to the panel session.</strong>
              </p>
              <TextBoxField
                value={newReviewerId}
                id="email"
                name="newReviewerId"
                displayError={this.state.emailError}
                handleChange={this.handleEmailChange}
                maxLength={101}
                errorMessages={emailError}
              />
            </div>
          )}
          {this.state.addPanelist === 'bulk' && (
            <div>
              {error && errorText ? (
                <Alert header="Upload error" type="error">
                  <strong>{errorText}</strong>
                </Alert>
              ) : (
                ''
              )}
              <p>
                To upload multiple panelists, please download the&nbsp;
                <a href={this.downloadTemplateLink()} target="_blank">
                  panelist upload template,
                </a>
                &nbsp;follow the instructions on 'Info' tab in the template and upload the
                list of panelists using the document uploader below. For FEMA users,
                please use PIV-ID email addresses (e.g. 012345678@dhs.gov) for access to
                competitive merit review sessions. Once you upload your panelists, you
                will see them in the panelist list where they will be initially listed as
                inactive until you are ready to activate them.
              </p>
              <div onClick={this.clearErrors}>
                {this.state.errorCode === 'NO_ROWS' && this.noRowsError()}
                <FileUpload
                  uploadAttachment={this.uploadAttachment}
                  acceptedFileTypes={['.xlsx']}
                  noFileDesc={true}
                  attachmentType="bulk-panelist-upload"
                />
              </div>
            </div>
          )}
        </Form>
      </FemaGoModal>
    );
  }
}

export default connectWithCore(PanelReviewAddReviewer);
